import {useMemo} from "react";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import {CROPS} from "../utils/enumItemsUtils";
import {Crop} from "../types/domain/crop";

export const useCrops = () => {
    const {t} = useTranslation();

    return useMemo(() => {
        const crops: Crop[] = CROPS.map((item) => ({id: item.id, name: t(`enumerations.crops.${item.i18nKey}`)}));

        return {
            crops,
            cropsById: _.keyBy(crops, "id"),
        };
    }, [t]);
};
